// AdminToolsPage.js
import React, { useState } from "react";

const AdminToolsPage = ({
                            onLaunchApproval,
                            onDeleteGradeStatus,
                            onRepairGradeColumn,
                            onUnlockCourses,
                            onDownloadTemplate
                        }) => {
    // Pre-fill date/time with "now"
    const now = new Date();
    const initialDate = now.toISOString().slice(0, 10); // yyyy-MM-dd
    const initialTime = now.toTimeString().slice(0, 5); // HH:mm

    // Grade Status Delete
    const [deleteDate, setDeleteDate] = useState(initialDate);
    const [deleteTime, setDeleteTime] = useState(initialTime);

    // Grade Column Repair
    const [repairCourseId, setRepairCourseId] = useState("");
    const [repairColumnName, setRepairColumnName] = useState("");

    // Course Unlock
    const [unlockCourseId, setUnlockCourseId] = useState("");
    const [unlockFile, setUnlockFile] = useState(null);
    const [notificationEmail, setNotificationEmail] = useState("");

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const clearMessages = () => {
        setMessage("");
        setError("");
    };

    const handleLaunchApproval = () => {
        clearMessages();
        try {
            if (onLaunchApproval) {
                onLaunchApproval();
            } else {
                console.log("[AdminTools] Launch Grades Approval and Transfer");
                window.alert(
                    "This would launch the Course Grades Approval and Transfer tool."
                );
            }
            setMessage("Grades Approval and Transfer launched.");
        } catch (err) {
            console.error("Launch approval failed:", err);
            setError("Failed to launch Grades Approval and Transfer.");
        }
    };

    const handleSubmitDelete = () => {
        clearMessages();
        const payload = { date: deleteDate, time: deleteTime };
        try {
            if (onDeleteGradeStatus) {
                onDeleteGradeStatus(payload);
            } else {
                console.log("[AdminTools] Grade Status Delete:", payload);
            }
            setMessage("Grade status delete request submitted.");
        } catch (err) {
            console.error("Grade status delete failed:", err);
            setError("Failed to submit grade status delete.");
        }
    };

    const handleSubmitRepair = () => {
        clearMessages();
        const payload = {
            courseId: repairCourseId.trim(),
            gradeColumnName: repairColumnName.trim()
        };
        if (!payload.courseId || !payload.gradeColumnName) {
            setError("Course ID and Grade Column Name are required for repair.");
            return;
        }
        try {
            if (onRepairGradeColumn) {
                onRepairGradeColumn(payload);
            } else {
                console.log("[AdminTools] Grade Column Repair:", payload);
            }
            setMessage("Grade column repair request submitted.");
        } catch (err) {
            console.error("Grade column repair failed:", err);
            setError("Failed to submit grade column repair.");
        }
    };

    const handleSubmitUnlock = () => {
        clearMessages();
        const payload = {
            courseId: unlockCourseId.trim(),
            file: unlockFile,
            notificationEmail: notificationEmail.trim()
        };
        if (!payload.courseId && !payload.file) {
            setError("Enter a Course ID or upload a file with multiple course IDs.");
            return;
        }
        try {
            if (onUnlockCourses) {
                onUnlockCourses(payload);
            } else {
                console.log("[AdminTools] Course Unlock:", payload);
            }
            setMessage("Course unlock request submitted.");
        } catch (err) {
            console.error("Course unlock failed:", err);
            setError("Failed to submit course unlock request.");
        }
    };

    const handleDownloadTemplate = () => {
        clearMessages();
        try {
            if (onDownloadTemplate) {
                onDownloadTemplate();
            } else {
                console.log("[AdminTools] Download template requested");
                window.alert(
                    "This would download a CSV template for multiple Course IDs."
                );
            }
        } catch (err) {
            console.error("Download template failed:", err);
            setError("Failed to download template.");
        }
    };

    return (
        <div style={{ padding: "12px 0", fontSize: 13 }}>
            {/* Messages */}
            {message && (
                <div style={{ marginBottom: 8, color: "#125", fontSize: 12 }}>
                    {message}
                </div>
            )}
            {error && (
                <div style={{ marginBottom: 8, color: "#a00", fontSize: 12 }}>
                    {error}
                </div>
            )}

            {/* Grades Approval and Transfer */}
            <Section title="Grades Approval and Transfer">
                <Row
                    label=""
                    control={
                        <>
                            <button type="button" onClick={handleLaunchApproval}>
                                Launch
                            </button>
                            <RowHelp>
                                Click to launch the Course Grades Approval and Transfer
                                tool.
                            </RowHelp>
                        </>
                    }
                />
            </Section>

            {/* Grade Status Delete */}
            <Section title="Grade Status Delete">
                <Row
                    label=""
                    control={
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    gap: 8,
                                    alignItems: "center",
                                    marginBottom: 6
                                }}
                            >
                                <input
                                    type="date"
                                    value={deleteDate}
                                    onChange={(e) => setDeleteDate(e.target.value)}
                                />
                                <input
                                    type="time"
                                    value={deleteTime}
                                    onChange={(e) => setDeleteTime(e.target.value)}
                                />
                            </div>
                            <RowHelp>
                                Select a date and time for deleting grade status records.
                                All grade statuses prior to the selected date and time
                                will be deleted.
                            </RowHelp>
                            <div style={{ marginTop: 8 }}>
                                <button type="button" onClick={handleSubmitDelete}>
                                    Submit
                                </button>
                            </div>
                        </>
                    }
                />
            </Section>

            {/* Grade Column Repair */}
            <Section title="Grade Column Repair">
                <Row
                    label="Course ID"
                    control={
                        <input
                            style={{ width: 260 }}
                            value={repairCourseId}
                            onChange={(e) => setRepairCourseId(e.target.value)}
                        />
                    }
                />
                <Row
                    label="Grade Column Name"
                    control={
                        <>
                            <input
                                style={{ width: 260 }}
                                value={repairColumnName}
                                onChange={(e) => setRepairColumnName(e.target.value)}
                            />
                            <RowHelp>
                                Enter a course ID and grade column name to repair the
                                grade column.
                            </RowHelp>
                            <div style={{ marginTop: 8 }}>
                                <button type="button" onClick={handleSubmitRepair}>
                                    Submit
                                </button>
                            </div>
                        </>
                    }
                />
            </Section>

            {/* Course Unlock */}
            <Section title="Course Unlock">
                <Row
                    label="Course ID"
                    control={
                        <>
                            <input
                                style={{ width: 260 }}
                                value={unlockCourseId}
                                onChange={(e) => setUnlockCourseId(e.target.value)}
                            />
                            <RowHelp>
                                Enter a course ID which needs to be unlocked.
                            </RowHelp>
                            <div style={{ marginTop: 8 }}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        // Single-course submit convenience
                                        if (!unlockCourseId.trim()) {
                                            setError(
                                                "Enter a Course ID before submitting single-course unlock."
                                            );
                                            return;
                                        }
                                        handleSubmitUnlock();
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </>
                    }
                />

                <Row
                    label="Multiple Course IDs"
                    control={
                        <>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <label
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 4
                                    }}
                                >
                                    <span
                                        style={{
                                            display: "inline-block",
                                            padding: "4px 10px",
                                            background: "#eee",
                                            borderRadius: 2,
                                            border: "1px solid #ccc",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Browse
                                    </span>
                                    <input
                                        type="file"
                                        accept=".csv,.txt"
                                        style={{ display: "none" }}
                                        onChange={(e) => {
                                            const file = e.target.files?.[0] || null;
                                            setUnlockFile(file || null);
                                        }}
                                    />
                                </label>
                                <button
                                    type="button"
                                    onClick={handleDownloadTemplate}
                                    title="Download Template"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "4px 8px"
                                    }}
                                >
                                    📄
                                </button>
                            </div>
                            <RowHelp>Download Template</RowHelp>
                        </>
                    }
                />

                <Row
                    label="Notification Email Address"
                    control={
                        <>
                            <input
                                style={{ width: 260 }}
                                value={notificationEmail}
                                onChange={(e) =>
                                    setNotificationEmail(e.target.value)
                                }
                            />
                            <RowHelp>
                                Please enter an email address if you would like to receive
                                a notification once the bulk unlock process has been
                                completed.
                            </RowHelp>
                        </>
                    }
                />

                <Row
                    label=""
                    control={
                        <div style={{ marginTop: 4 }}>
                            <button type="button" onClick={handleSubmitUnlock}>
                                Submit
                            </button>
                        </div>
                    }
                />
            </Section>
        </div>
    );
};

/* ---- layout helpers (same pattern as other pages) ---- */

const Section = ({ title, children }) => (
    <div style={{ marginBottom: 20 }}>
        <div
            style={{
                fontWeight: 600,
                marginBottom: 6,
                marginTop: 6
            }}
        >
            {title}
        </div>
        <div
            style={{
                borderTop: "1px solid #eee",
                paddingTop: 8,
                display: "grid",
                rowGap: 8
            }}
        >
            {children}
        </div>
    </div>
);

const Row = ({ label, control }) => (
    <div
        style={{
            display: "grid",
            gridTemplateColumns: "220px minmax(200px, 640px)",
            columnGap: 16,
            alignItems: "flex-start",
            marginBottom: 4
        }}
    >
        <div style={{ fontSize: 12, fontWeight: 600, paddingTop: 4 }}>
            {label}
        </div>
        <div>{control}</div>
    </div>
);

const RowHelp = ({ children }) => (
    <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2 }}>{children}</div>
);

export default AdminToolsPage;
